import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
export interface LinkAndIconCellRendererParams {
  showLink?: boolean;
  url?: string;
  showIcon?: boolean;
  iconClass?: string;
  defaultContent?: string;
}

@Component({
    selector: 'app-link-and-icon-cell-renderer',
    template: `@if(showLink && showIcon){
    <a [href]="url"><i [class]="iconClass"></i></a>
    } @else if (showIcon) {
    <i [class]="iconClass"></i>
    } @else {
    {{ defaultContent }}
    } `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LinkAndIconCellRendererComponent
  implements ICellRendererAngularComp
{
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  showLink?: boolean;
  url?: string;
  showIcon?: boolean;
  iconClass?: string;
  defaultContent?: string;

  agInit({
    showLink,
    url,
    showIcon,
    defaultContent,
    iconClass,
  }: CustomParams): void {
    this.showLink = showLink;
    this.url = url;
    this.showIcon = showIcon;
    this.iconClass = iconClass;
    this.defaultContent = defaultContent;
    this.changeDetectorRef.detectChanges();
  }
  refresh(): boolean {
    return false;
  }
}
interface CustomParams
  extends ICellRendererParams<unknown, unknown>,
    LinkAndIconCellRendererParams {}
